import Firebase from "firebase";
var config = {
  apiKey: "AIzaSyCVCGlOat9NxZA_WqxuHOLNz2pNn90YDI0",
  authDomain: "rambler-jal.firebaseapp.com",
  databaseURL: "https://rambler-jal.firebaseio.com",
  projectId: "rambler-jal",
  storageBucket: "rambler-jal.appspot.com",
  messagingSenderId: "115478367026"
};
let app = Firebase.initializeApp(config);
export const db = app.database();
